import { render, staticRenderFns } from "./CompensatoryInput.vue?vue&type=template&id=3ece38f5&"
import script from "./CompensatoryInput.vue?vue&type=script&lang=js&"
export * from "./CompensatoryInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports